export default [
  {
    game_name: "邪瞳专属单职业",
    ip: "真特色单职系统",
    type: "996精品推荐",
    line: "长久耐玩可搬砖",
    detail: "长久耐玩多图打◆宝等级好升长久服",
    qq: "特色推荐爆▃",
    game_id: "3800097",
    plan: "B",
  },
  {
    game_name: "▁黄泉火龙大极品▃",
    ip: "█火龙打宝追梦服",
    type: "997精品推荐",
    line: "双号开荒〃",
    detail: "※双号开荒材料可打多图打宝长期真耐玩",
    qq: "━新特色推荐★",
    game_id: "3800096",
    plan: "B",
  },
  {
    game_name: "道观复古沉默",
    ip: "复古◆长服",
    type: "998精品推荐",
    line: "灬多图打宝真耐玩",
    detail: "▁多图打宝爆率全开职业丰富长久服▃",
    qq: "▁高爆推荐爽",
    game_id: "3800109",
    plan: "B",
  },
  {
    game_name: "灬文狸墨竹特戒",
    ip: "█经典三职首战区",
    type: "999精品推荐",
    line: "爆散人友好模式",
    detail: "※散人友好魔王高爆爆·",
    qq: "━真魔王推荐★",
    game_id: "3800053",
    plan: "B",
  },
  {
    game_name: "━纯PC小呆瓜破坏神★",
    ip: "◆纯PC·服模式",
    type: "1000精品推荐",
    line: "经典耐玩★",
    detail: "█经典耐玩操作简单热血开荒冲",
    qq: "经典特◆色推荐",
    game_id: "3800002",
    plan: "B",
  },
  {
    game_name: "琴台神器专属╊",
    ip: "神器追梦首战区〃",
    type: "1001精品推荐",
    line: "灬等级好升",
    detail: "等级好升专属神器打金服▃",
    qq: "经典特◆色推荐",
    game_id: "3800086",
    plan: "B",
  },
  {
    game_name: "※霁月火龙单职业",
    ip: "特色※单职╊",
    type: "1002精品推荐",
    line: "━新长久耐玩★",
    detail: "长久耐玩等级好◆升装备靠打散人服",
    qq: "特色推荐〃",
    game_id: "3800088",
    plan: "B",
  },
  {
    game_name: "朱砂战神三职业",
    ip: "经典三职",
    type: "1003精品推荐",
    line: "▁无坑公平追梦服",
    detail: "无坑公平装备回收爽〃",
    qq: "※特色推荐·",
    game_id: "3800101",
    plan: "B",
  },
  {
    game_name: "裂空神器专属〃",
    ip: "※神器追梦·",
    type: "1004精品推荐",
    line: "长久无坑公平玩法",
    detail: "无坑公平魔王高爆多图打宝起飞★",
    qq: "※魔王推荐",
    game_id: "3800094",
    plan: "B",
  },
  {
    game_name: "▁怒雷天之冰雪▃",
    ip: "纯PC服可搬砖╊",
    type: "1005精品推荐",
    line: "特色玩法★",
    detail: "※特色玩法热血开荒经典耐玩冲·",
    qq: "长久特色推荐▃",
    game_id: "3800075",
    plan: "B",
  },
  {
    game_name: "▁归鸦沉默单职业▃",
    ip: "※特色单职可搬砖",
    type: "1006精品推荐",
    line: "灬长久耐玩",
    detail: "长久耐玩新区连开开战",
    qq: "━新特色推荐★",
    game_id: "3800092",
    plan: "B",
  },
  {
    game_name: "▁沉默华夏",
    ip: "沉默专属▃",
    type: "1007精品推荐",
    line: "经典耐玩必体验★",
    detail: "经典耐玩操作简单爽〃",
    qq: "※特色推荐·",
    game_id: "111661",
    plan: "B",
  },
  {
    game_name: "书斋迷◆失神器",
    ip: "神器追梦今日首战",
    type: "1008精品推荐",
    line: "长久无坑公平★",
    detail: "无坑公平魔王高爆多图打宝散人必玩╊",
    qq: "█魔王推荐",
    game_id: "3800105",
    plan: "B",
  },
  {
    game_name: "刀域神器专属▃",
    ip: "神器◆追梦",
    type: "1009精品推荐",
    line: "█零氪畅玩散人服",
    detail: "※零氪畅玩装备回收专属神器长期真耐玩",
    qq: "※特色推荐·",
    game_id: "3800102",
    plan: "B",
  },
  {
    game_name: "玄策沉默专属╊",
    ip: "※经典三职·",
    type: "1010精品推荐",
    line: "经典泡点升级〃",
    detail: "泡点升级货币可打神宠助战爆",
    qq: "货币◆推荐",
    game_id: "3800049",
    plan: "B",
  },
  {
    game_name: "酒庐◆传奇1",
    ip: "纯PC服可搬砖★",
    type: "1011精品推荐",
    line: "爆经典耐玩",
    detail: "█经典耐玩操作简单热血开荒燃",
    qq: "█全新特色推荐",
    game_id: "3800107",
    plan: "B",
  },
  {
    game_name: "血池攻※速无限刀╊",
    ip: "经典神器追梦模式",
    type: "1012精品推荐",
    line: "▁魔王高爆可搬砖",
    detail: "※魔王高爆专属神器散人友好散人来追梦",
    qq: "灬特色推荐爽",
    game_id: "3800095",
    plan: "B",
  },
  {
    game_name: "刀域火龙〃",
    ip: "经典※三职╊",
    type: "1013精品推荐",
    line: "※长久首爆奖励",
    detail: "首爆奖励泡点升级刚开服▃",
    qq: "灬升级推荐",
    game_id: "3800081",
    plan: "B",
  },
  {
    game_name: "无定赤月大极品",
    ip: "纯PC服追梦服〃",
    type: "1014精品推荐",
    line: "散人友好",
    detail: "散人友好泡点※升级魔王高爆爆╊",
    qq: "▁爆升级推荐▃",
    game_id: "3800080",
    plan: "B",
  },
  {
    game_name: "霁月攻速单职业╊",
    ip: "━真特色单职★",
    type: "1015精品推荐",
    line: "散人◆友好区",
    detail: "散人友好装备回收自动回收刚开服",
    qq: "灬特色推★荐模式",
    game_id: "3800054",
    plan: "B",
  },
  {
    game_name: "※墨染微变单职业·",
    ip: "特色单职▃",
    type: "1016精品推荐",
    line: "█等级好升可搬砖",
    detail: "▁等级好升新区连开必玩▃",
    qq: "特色※推荐╊",
    game_id: "3800078",
    plan: "B",
  },
  {
    game_name: "◆墨杀攻·速单职业",
    ip: "长久特色单职▃",
    type: "1017精品推荐",
    line: "装备※靠打╊",
    detail: "※装备靠打等级好升攻速拉满散人来追梦",
    qq: "灬特色推★荐玩法",
    game_id: "3800045",
    plan: "B",
  },
  {
    game_name: "▁素霓传奇2",
    ip: "█纯PC服",
    type: "1018精品推荐",
    line: "▁经典耐玩可搬砖",
    detail: "经典耐玩操作简单开战",
    qq: "特色※推荐╊",
    game_id: "3800104",
    plan: "B",
  },
  {
    game_name: "◆断猿摸·金传奇",
    ip: "长久高爆专服系统",
    type: "1019精品推荐",
    line: "切割※狂暴╊",
    detail: "▲切割狂暴特色玩法长久服◆",
    qq: "█特色推荐散人服",
    game_id: "3800093",
    plan: "B",
  },
  {
    game_name: "▲禅院传奇1◆",
    ip: "※纯PC服爆",
    type: "1020精品推荐",
    line: "长久经典耐玩▃",
    detail: "◆经典耐玩操作简·单热血开荒首战区",
    qq: "▁特色推荐",
    game_id: "3800108",
    plan: "B",
  },
  {
    game_name: "暮雪沉默三职业╊",
    ip: "经典三职稳▃",
    type: "1021精品推荐",
    line: "▁全新等级好升",
    detail: "等级好升职业丰富装备回收激情开荒╊",
    qq: "特色推荐〃",
    game_id: "3800090",
    plan: "B",
  },
  {
    game_name: "残照狂徒迷失╊",
    ip: "爆高爆专服玩法",
    type: "1022精品推荐",
    line: "等级好升稳",
    detail: "等级好升多图打宝神宠助战激情开荒╊",
    qq: "特色推荐可搬砖〃",
    game_id: "3800089",
    plan: "B",
  },
  {
    game_name: "书斋沉默专属",
    ip: "沉默专属必体验",
    type: "1023精品推荐",
    line: "█全新多图打宝",
    detail: "灬多图打宝装备回★收职业丰富首战区",
    qq: "▁特色推荐",
    game_id: "3800110",
    plan: "B",
  },
  {
    game_name: "█无常专属神器",
    ip: "神器追梦新区开荒",
    type: "1024精品推荐",
    line: "▁爆装备回收▃",
    detail: "灬装备回收攻速拉满★多图打宝散人必玩",
    qq: "经典攻速推荐",
    game_id: "3800100",
    plan: "B",
  },
  {
    game_name: "未休魅影骷髅王",
    ip: "▁全新纯PC服",
    type: "1025精品推荐",
    line: "无坑公平稳★",
    detail: "无坑公平特色玩法█长久耐玩散人必玩〃",
    qq: "特色推荐必体验★",
    game_id: "3800057",
    plan: "B",
  },
  {
    game_name: "踵武仙剑沉默",
    ip: "━新沉默专属★",
    type: "1026精品推荐",
    line: "泡点◆升级稳",
    detail: "泡点升级魔王高爆装备回收起飞★",
    qq: "▁魔王推荐真耐玩",
    game_id: "3800060",
    plan: "B",
  },
  {
    game_name: "█钜峰复古沉默",
    ip: "━新复古长服★",
    type: "1027精品推荐",
    line: "长久※耐玩╊",
    detail: "※长久耐玩神宠助战上线领礼散人来追梦",
    qq: "特色推荐追梦服★",
    game_id: "3800050",
    plan: "B",
  },
  {
    game_name: "衍月灵猫传奇",
    ip: "灬经典三★职玩法",
    type: "1028精品推荐",
    line: "█职业丰富",
    detail: "█职业丰富魔王高爆神宠助战冲",
    qq: "全新魔王推荐",
    game_id: "3800052",
    plan: "B",
  },
  {
    game_name: "枯荷高※爆神器╊",
    ip: "神器追梦★",
    type: "1029精品推荐",
    line: "多图打宝真耐玩",
    detail: "多图打宝装备回收自动回收新区首战╊",
    qq: "※特色推荐区",
    game_id: "3800056",
    plan: "B",
  },
  {
    game_name: "啼鹃变速狂刀",
    ip: "经典纯◆PC服",
    type: "1030精品推荐",
    line: "零氪畅玩区",
    detail: "零氪畅玩切割狂暴首战区",
    qq: "特色推◆荐可搬砖",
    game_id: "3800062",
    plan: "B",
  },
  {
    game_name: "※归鸦无限刀",
    ip: "▁纯PC服散人服",
    type: "1031精品推荐",
    line: "※上线领礼",
    detail: "灬上线领礼经典耐玩特色玩法",
    qq: "经典特◆色推荐",
    game_id: "3800059",
    plan: "B",
  },
  {
    game_name: "画舫微变三职业★",
    ip: "全新经典三职路线",
    type: "1032精品推荐",
    line: "职业◆丰富稳",
    detail: "▲职业丰富等级好升长久耐玩打金服◆",
    qq: "特色推荐首战区▃",
    game_id: "3800106",
    plan: "B",
  },
  {
    game_name: "灬琴台攻速无限刀",
    ip: "沉默专属首战区",
    type: "1033精品推荐",
    line: "多图打宝〃",
    detail: "多图打宝切割狂暴散人友好开战",
    qq: "█全新特色推荐",
    game_id: "3800103",
    plan: "B",
  },
  {
    game_name: "墨染微变三职业★",
    ip: "━新经典三职★",
    type: "1034精品推荐",
    line: "无坑※公平╊",
    detail: "无坑公平魔王高爆多图打宝散人必玩╊",
    qq: "█魔王推荐真耐玩",
    game_id: "3800099",
    plan: "B",
  },
  {
    game_name: "裂空合击〃",
    ip: "合击专服",
    type: "1035精品推荐",
    line: "装备保值模式",
    detail: "装备保值经典耐玩散人服▃",
    qq: "特色推荐",
    game_id: "3800066",
    plan: "B",
  },
  {
    game_name: "百破灵猫沉默╊",
    ip: "沉默专属★",
    type: "1036精品推荐",
    line: "多图打◆宝真耐玩",
    detail: "━多图打宝经典耐玩特色玩法★",
    qq: "※特色推荐区",
    game_id: "3800068",
    plan: "B",
  },
  {
    game_name: "无常沉默三职业╊",
    ip: "经典三职今日首战",
    type: "1037精品推荐",
    line: "━真长久耐玩★",
    detail: "◆长久耐玩等级·好升装备靠打爽",
    qq: "特色推荐〃",
    game_id: "3800074",
    plan: "B",
  },
  {
    game_name: "刀藏诛仙专属",
    ip: "灬火龙打★宝模式",
    type: "1038精品推荐",
    line: "█装备回收",
    detail: "※装备回收材料可打必玩·",
    qq: "全新特色推荐玩法",
    game_id: "3800048",
    plan: "B",
  },
  {
    game_name: "▁霜雪鲁王传奇",
    ip: "█全新纯PC服",
    type: "1039精品推荐",
    line: "※散人友好·",
    detail: "▁散人友好装备回收开战",
    qq: "特色推荐路线",
    game_id: "3800065",
    plan: "B",
  },
  {
    game_name: "暮雪渝乐复古",
    ip: "全新经典三职╊",
    type: "1040精品推荐",
    line: "装备靠打服",
    detail: "█装备靠打装备保值等级好升燃",
    qq: "灬特色推荐散人服",
    game_id: "3800058",
    plan: "B",
  },
  {
    game_name: "灬枯荷180★小极品",
    ip: "经典纯◆PC服",
    type: "1041精品推荐",
    line: "装备回收稳★",
    detail: "※装备回收散人友好泡点升级长期真耐玩",
    qq: "散人推荐可搬砖▃",
    game_id: "3800091",
    plan: "B",
  },
  {
    game_name: "素霓战神三职业",
    ip: "经典三职服",
    type: "1042精品推荐",
    line: "※神宠助战",
    detail: "神宠助战魔王高※爆多图打宝首战区╊",
    qq: "全新魔王推荐╊",
    game_id: "3800084",
    plan: "B",
  },
  {
    game_name: "锈刀专属神器╊",
    ip: "▁爆沉默专属▃",
    type: "1043精品推荐",
    line: "装备回收",
    detail: "装备回收多图打宝装备保值追梦★",
    qq: "※特色推荐追梦服",
    game_id: "3800098",
    plan: "B",
  },
  {
    game_name: "◆朱砂复·古沉默",
    ip: "━真复古长服★",
    type: "1044精品推荐",
    line: "▁神宠助战爽",
    detail: "神宠助战装备回收打金服",
    qq: "灬特色推★荐模式",
    game_id: "3800079",
    plan: "B",
  },
  {
    game_name: "灬断猿沉默专属",
    ip: "沉默※专属╊",
    type: "1045精品推荐",
    line: "━新专属神器★",
    detail: "专属神器爆率全开多图打宝起飞★",
    qq: "高爆推荐",
    game_id: "3800063",
    plan: "B",
  },
  {
    game_name: "血池火龙三职业",
    ip: "爆经典三职",
    type: "1046精品推荐",
    line: "新区连开追梦服〃",
    detail: "新区连开魔王高爆刚开服▃",
    qq: "魔王推荐区▃",
    game_id: "3800067",
    plan: "B",
  },
  {
    game_name: "灬邪瞳无限刀",
    ip: "神器追梦〃",
    type: "1047精品推荐",
    line: "◆泡点升·级模式",
    detail: "泡点升级专属神器散人服▃",
    qq: "特色推荐爆╊",
    game_id: "3800073",
    plan: "B",
  },
  {
    game_name: "◆展锋飞·羽沉默",
    ip: "长久经典三职系统",
    type: "1048精品推荐",
    line: "泡点升级爽╊",
    detail: "泡点升级货币可打神宠助战起飞★",
    qq: "灬货币推★荐模式",
    game_id: "3800051",
    plan: "B",
  },
  {
    game_name: "墨杀神器单职业",
    ip: "◆特色单·职玩法",
    type: "1049精品推荐",
    line: "█长久耐玩",
    detail: "长久耐玩魔王高爆激情攻沙必玩",
    qq: "▁真魔王推荐▃",
    game_id: "3800087",
    plan: "B",
  },
  {
    game_name: "锈刀微变三职业",
    ip: "█经典三职追梦服",
    type: "1050精品推荐",
    line: "等级◆好升",
    detail: "等级好升魔※王高爆散人服╊",
    qq: "▁真魔王推荐▃",
    game_id: "3800064",
    plan: "B",
  },
  {
    game_name: "黄泉复古三职业〃",
    ip: "※经典三职",
    type: "1051精品推荐",
    line: "多图打宝必体验〃",
    detail: "█多图打宝爆率全开装备回收冲",
    qq: "高爆※推荐╊",
    game_id: "3800071",
    plan: "B",
  },
  {
    game_name: "2003记忆传奇",
    ip: "纯PC服服",
    type: "1052精品推荐",
    line: "━新经典耐玩★",
    detail: "经典耐玩操作简单散人服▃",
    qq: "真特色推荐",
    game_id: "111188",
    plan: "B",
  },
  {
    game_name: "残照迷※失单职业╊",
    ip: "特色单职▃",
    type: "1053精品推荐",
    line: "装备靠打追梦服〃",
    detail: "━装备靠打装备保值等级好升★",
    qq: "※特色推荐·",
    game_id: "3800055",
    plan: "B",
  },
  {
    game_name: "碧影王土无限刀",
    ip: "※高爆专服·",
    type: "1054精品推荐",
    line: "▁真上线领礼▃",
    detail: "灬上线领礼散★人友好追梦",
    qq: "▁散人推荐",
    game_id: "3800061",
    plan: "B",
  },
  {
    game_name: "█酒庐复古大陆",
    ip: "▁复古长服可搬砖",
    type: "1055精品推荐",
    line: "真无坑公平",
    detail: "※无坑公平魔王高爆多图打宝冲·",
    qq: "━新魔王推荐★",
    game_id: "3800107",
    plan: "B",
  },
];
